import Panel from '../../../assets/svg/chests/chest-panel.svg';
import Rocket from '../../../assets/svg/utils/rocket/rocket.svg';
import CyanPanel from '../../../assets/svg/utils/panels/cyan-panel.svg';
import PurplePanel from '../../../assets/svg/utils/panels/purple-panel.svg';
import CyanRect from '../../../assets/svg/rects/cyan.svg';
import BluredAlien from '../../../assets/images/characters/alien-with-blue-blur.png';
import { useRocketCoins } from '../../../hooks/useRocketCoins';

function DropBankInfo() {
  const { rocketCoins, rocketCoinsPerHour } = useRocketCoins();

  return (
    <div
      className="
        flex flex-col items-center
        font-Bangers
        mt-[39px]
      "
    >
      <span className="text-[32px]">drop bank</span>
      <span className="text-lg">balance</span>
      <div
        className="
            relative
            max-w-[295px] w-full
            mx-auto
            z-[1]
            mt-[51px]
        "
      >
        <img
          src={Panel}
          alt="panel"
          className="
            absolute
            left-1/2
            -translate-x-1/2
            scale-[1.15]
          "
          width={330}
        />
        <img
          src={BluredAlien}
          alt="alien"
          width={160}
          className="
            absolute
            top-[-76px]
            right-[-25px]
            z-[-1]
          "
        />
        <img
          src={Rocket}
          alt="rocket"
          width={94}
          className="
            relative
            z-1
            left-[8%] top-[-12px]
          "
        />
        <div
          className="
            absolute
            top-1/2 left-1/2
            -translate-x-1/4
            -translate-y-1/2
            flex items-center gap-2
          "
        >
          <span className="text-[32px]">
            {parseFloat(rocketCoins.toFixed(3))}
          </span>
          <span className="font-Inria text-[10px] text-nowrap text-[#B5C4FC]">Total Rockets</span>
        </div>
        <div
          className="
            absolute
            top-[100%]
            left-1/2
            translate-y-[-70%]
            -translate-x-1/2
          "
        >
          <img src={CyanPanel} alt="cyan-panel" />
          <div
            className="
                flex items-center gap-1
                absolute
                top-[50%]
                left-1/2
                -translate-y-2/3
                -translate-x-1/2
            "
          >
            <span className="text-dodgerBlue200 text-xs">{rocketCoinsPerHour.toFixed(3)}</span>
            <span className="text-[#B5C4FC] text-[8px] font-Inria text-nowrap">per hour</span>
          </div>
        </div>
      </div>
      <div
        className="
            relative
            top-[-10px]
            flex items-center
        "
      >
        <img src={PurplePanel} alt="purple-panel" width={280} />
        <img
          src={CyanRect}
          alt="cyan-rect"
          width={140}
          className="
            absolute
            top-[100%]
            left-1/2
            -translate-x-1/2
          "
        />
        <ul
          className="
            bank-drop-info-list
            font-Inria
            text-xs
          "
        >
          <li className="text-start">Collect rockets as points for drop</li>
          <li className="text-start">Send all to the moon</li>
          <li className="text-start">Collect rockets as points for drop</li>
        </ul>
      </div>
    </div>
  );
}

export default DropBankInfo;
